/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Starter,
  StarterDto,
  StarterHistoryItemDto,
  StarterResponse,
  ShowStarterDto,
} from '../models/index';
import {
    StarterFromJSON,
    StarterToJSON,
    StarterDtoFromJSON,
    StarterDtoToJSON,
    StarterHistoryItemDtoFromJSON,
    StarterResponseFromJSON,
    StarterResponseToJSON,
    ShowStarterDtoFromJSON,
} from '../models/index';

export interface ApiStartersPostRequest {
    starterDto?: StarterDto;
}

export interface ApiStartersShowShowIdBookerBookerIdGetRequest {
    showId: number;
    bookerId: string;
}

export interface ApiStartersShowShowIdStarterGetRequest {
    showId: number;
}

export interface ApiStartersValidatePostRequest {
    starterDto?: StarterDto;
}

export interface ApiStartersHistoryHorseRegisterIdGetRequest {
    registerId: string;
}

export interface ApiStartersHistoryRiderRegisterIdGetRequest {
    registerId: string;
}

/**
 * 
 */
export class StartersApi extends runtime.BaseAPI {

    /**
     */
    async apiStartersPostRaw(requestParameters: ApiStartersPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Starter>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Starters`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StarterDtoToJSON(requestParameters['starterDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StarterFromJSON(jsonValue));
    }

    /**
     */
    async apiStartersPost(requestParameters: ApiStartersPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Starter> {
        const response = await this.apiStartersPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiStartersShowShowIdBookerBookerIdGetRaw(requestParameters: ApiStartersShowShowIdBookerBookerIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StarterResponse>>> {
        if (requestParameters['showId'] == null) {
            throw new runtime.RequiredError(
                'showId',
                'Required parameter "showId" was null or undefined when calling apiStartersShowShowIdBookerBookerIdGet().'
            );
        }

        if (requestParameters['bookerId'] == null) {
            throw new runtime.RequiredError(
                'bookerId',
                'Required parameter "bookerId" was null or undefined when calling apiStartersShowShowIdBookerBookerIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Starters/show/{showId}/booker/{BookerId}`.replace(`{${"showId"}}`, encodeURIComponent(String(requestParameters['showId']))).replace(`{${"BookerId"}}`, encodeURIComponent(String(requestParameters['bookerId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StarterResponseFromJSON));
    }

    /**
     */
    async apiStartersShowShowIdBookerBookerIdGet(requestParameters: ApiStartersShowShowIdBookerBookerIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StarterResponse>> {
        const response = await this.apiStartersShowShowIdBookerBookerIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiStartersValidatePostRaw(requestParameters: ApiStartersValidatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Starters/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StarterDtoToJSON(requestParameters['starterDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiStartersValidatePost(requestParameters: ApiStartersValidatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiStartersValidatePostRaw(requestParameters, initOverrides);
    }

    /** Historie aller Starts eines Pferdes */
    async apiStartersHistoryHorseRegisterIdGetRaw(requestParameters: ApiStartersHistoryHorseRegisterIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StarterHistoryItemDto>>> {
        if (requestParameters['registerId'] == null) {
            throw new runtime.RequiredError('registerId', 'Required parameter "registerId" was null or undefined.');
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY");
        }
        const response = await this.request({
            path: `/api/Starters/history/horse/${encodeURIComponent(requestParameters['registerId'])}`,
            method: 'GET',
            headers: headerParameters,
            query: {},
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StarterHistoryItemDtoFromJSON));
    }

    async apiStartersHistoryHorseRegisterIdGet(requestParameters: ApiStartersHistoryHorseRegisterIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StarterHistoryItemDto>> {
        const response = await this.apiStartersHistoryHorseRegisterIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /** Historie aller Starts eines Reiters */
    async apiStartersHistoryRiderRegisterIdGetRaw(requestParameters: ApiStartersHistoryRiderRegisterIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StarterHistoryItemDto>>> {
        if (requestParameters['registerId'] == null) {
            throw new runtime.RequiredError('registerId', 'Required parameter "registerId" was null or undefined.');
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY");
        }
        const response = await this.request({
            path: `/api/Starters/history/rider/${encodeURIComponent(requestParameters['registerId'])}`,
            method: 'GET',
            headers: headerParameters,
            query: {},
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StarterHistoryItemDtoFromJSON));
    }

    async apiStartersHistoryRiderRegisterIdGet(requestParameters: ApiStartersHistoryRiderRegisterIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StarterHistoryItemDto>> {
        const response = await this.apiStartersHistoryRiderRegisterIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /** Alle Starter einer Show */
    async apiStartersShowShowIdStarterGetRaw(requestParameters: ApiStartersShowShowIdStarterGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ShowStarterDto>>> {
        if (requestParameters['showId'] == null) {
            throw new runtime.RequiredError('showId', 'Required parameter "showId" was null or undefined.');
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY");
        }
        const response = await this.request({
            path: `/api/Starters/show/${encodeURIComponent(String(requestParameters['showId']))}/starter`,
            method: 'GET',
            headers: headerParameters,
            query: {},
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ShowStarterDtoFromJSON));
    }

    async apiStartersShowShowIdStarterGet(requestParameters: ApiStartersShowShowIdStarterGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ShowStarterDto>> {
        const response = await this.apiStartersShowShowIdStarterGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
